<script setup lang="ts">
import type { NuxtError } from "#app";
import MPFooter from "./components/layouts/MPFooter.vue";
import MPHeader from "./components/layouts/MPHeader.vue";

const props = defineProps<{
  error: NuxtError;
}>();

console.error(props.error);
</script>

<template>
  <div class="flex-wrapper">
    <MPHeader class="app-header" />
    <div class="app-content">
      <div class="app-wrapper error-page">
        <span v-if="props.error">{{ props.error.statusCode }} ERROR</span>
        <h3 v-if="props.error">Oops... {{ props.error.statusMessage }}</h3>
        <p v-if="props.error?.statusCode === 404">
          The page you requested could not be found.
        </p>
        <p v-else>
          We apologize there was an error with the application. If the error
          persists please contact support.
        </p>
        <div class="help-tips">
          <div>
            <strong><i class="ri-link" />Check the URL</strong>
            <p>
              Make sure the URL is correct. A small typo could have been the
              problem.
            </p>
          </div>
          <div>
            <strong><i class="ri-questionnaire-line" />Contact Support</strong>
            <p>
              If this is a persistent issue thats effecting you please
              <a href="mailto:hello@mappr.com">contact support</a>
            </p>
          </div>
          <div>
            <strong><i class="ri-arrow-left-circle-line" />Go back</strong>
            <p>
              <NuxtLink to="/" external
                >Navigate back to the home page</NuxtLink
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <MPFooter class="app-footer" />
  </div>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/breakpoints.pcss";
.app-content {
  display: grid;
  align-content: space-evenly;
}
.error-page {
  margin: 0 auto;
  text-align: center;
  height: fit-content;
  width: 100%;
  padding: 3rem 2rem;
  @mixin screen md {
    margin-top: 4rem;
  }
  p {
    font-size: 1.1rem;
    color: var(--color-slate-500);
    max-width: 28rem;
    line-height: 1.5;
    margin: 0 auto;
  }
  span {
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--color-indigo-400);
  }
  .help-tips {
    display: grid;
    gap: 1rem;
    margin: 6rem auto 0;
    max-width: 60rem;
    text-align: left;
    @mixin screen md {
      grid-template-columns: repeat(3, 1fr);
    }
    a,
    a:visited {
      color: var(--color-indigo-400);
      cursor: pointer;
    }
    i {
      color: var(--color-indigo-400);
      margin-right: 0.5rem;
      font-size: 110%;
    }
    p {
      margin: 0;
    }
    > div {
      background-color: var(--color-slate-50);
      color: var(--color-slate-700);
      padding: 1rem 1.5rem 1.5rem;
      border-radius: 1rem;
      strong {
        font-size: 1.1rem;
        line-height: 2.5;
      }
    }
  }
}
.flex-wrapper {
  display: flex;
  min-height: 100vh;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
}
.app-footer {
  margin-top: auto;
}
</style>
